import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "chatbot-input p-4 border-t border-gray-200 bg-white transition-all duration-300" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "flex-1 mr-2" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "relative inline-flex items-center mr-3" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "h-3.5 w-3.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = {
  key: 1,
  class: "h-3.5 w-3.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          ref: "messageInput",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.messageText) = $event)),
          placeholder: "Type your message here...",
          class: "w-full px-4 py-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]), ["enter"])),
          disabled: _ctx.disabled
        }, null, 40, _hoisted_4), [
          [_vModelText, _ctx.messageText]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleMode && _ctx.toggleMode(...args))),
          class: _normalizeClass(["px-2 py-1 text-sm font-medium rounded-md transition-all duration-300 flex items-center space-x-1 group", _ctx.isFastmodeActive ? 'text-blue-700' : 'text-gray-600']),
          disabled: _ctx.disabled
        }, [
          (_ctx.isFastmodeActive)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _cache[4] || (_cache[4] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M13 10V3L4 14h7v7l9-11h-7z"
                }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("svg", _hoisted_8, _cache[5] || (_cache[5] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                }, null, -1)
              ]))),
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("span", {
              class: _normalizeClass(["transition-opacity duration-300", {'opacity-100': _ctx.isFastmodeActive, 'opacity-0 absolute': !_ctx.isFastmodeActive}])
            }, "FastMode", 2),
            _createElementVNode("span", {
              class: _normalizeClass(["transition-opacity duration-300", {'opacity-100': !_ctx.isFastmodeActive, 'opacity-0 absolute': _ctx.isFastmodeActive}])
            }, "DeepMode", 2)
          ])
        ], 10, _hoisted_6)
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
        class: _normalizeClass(["p-3 bg-blue-700 text-white rounded-full hover:bg-blue-800 transition-colors flex-shrink-0 flex items-center justify-center", { 'opacity-50 cursor-not-allowed': !_ctx.messageText.trim() || _ctx.disabled }]),
        disabled: !_ctx.messageText.trim() || _ctx.disabled
      }, _cache[6] || (_cache[6] = [
        _createElementVNode("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M2 21L23 12L2 3L2 10L17 12L2 14L2 21Z",
            fill: "currentColor"
          })
        ], -1)
      ]), 10, _hoisted_10)
    ])
  ]))
}